module.exports = __webpack_public_path__ + "static/img/h-2.1e32353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/h-2.jpg
// module id = nLi1
// module chunks = 1